module.exports = __webpack_public_path__ + "static/img/shi5_1.b020448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shi5_1.png
// module id = 9QfJ
// module chunks = 1